import { jsonAxios } from "components/axios";
import CustomSelect, { ISelectOption } from "./CustomSelect"
import { useCallback, useEffect, useState } from "react";

interface IPortSelect {
    className?: string;
    transportType: string;
    placeholder: string;
    value: string;
    disabled?: boolean
    onChange?: (allData: ISelectOption) => void;
    width?: string
    height?: number
    fontSize?: number
    transitAddress?: string
    position?: 'top' | 'auto' | 'bottom'
}

const PortSelect = ({
    className,
    transportType,
    value,
    placeholder,
    onChange,
    disabled,
    height = 60,
    width,
    fontSize = 16,
    transitAddress,
    position
}: IPortSelect) => {
    interface IServerList {
        id: number,
        locationCode: string
        locationNameEn?: string
        locationNameKr?: string
        countryCode?: string
    }

    const [list, setList] = useState<ISelectOption[]>([])
    const [keyword, setKeyword] = useState<string>('')
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true)
    }, [transportType])

    const getLocations = useCallback(() => {
        if (!transportType) return
        const searchValue = keyword !== '' ? keyword : (transitAddress || '');
        jsonAxios.get(`/locations?locationType=${transportType}&search=${searchValue}`).then(res => {
            if (res.data.code === 200) {
                const serverList: IServerList[] = res.data.data
                if (serverList.length > 0) {
                    const temp: ISelectOption[] = serverList.map((item) => (
                        {
                            value: String(item.id),
                            label: item.locationNameKr
                                ? `${item.countryCode ?? ''}${item.locationCode} | ${item.locationNameKr} | ${item.locationNameEn}`
                                : `${item.countryCode ?? ''}${item.locationCode} | ${item.locationNameEn}`,
                            labelEn: item.locationNameEn,
                        }
                    ))
                    setList(temp)
                }
            }
            setTimeout(() => {
                setIsLoading(false)
            }, 200)
        })
    }, [keyword, transportType, transitAddress])

    useEffect(() => {
        getLocations();
    }, [getLocations])

    const filterdSelect = (list: ISelectOption[], value: string) => {
        const filtered = list.find(arr => arr.value === value)
        return filtered || undefined
    }

    return (
        isLoading ?
            <div
                className={`border border-[#9D9EB7] text-[#B5B5B5] rounded-lg flex items-center px-8 ${className} 
                ${width ? width : 'w-[320px]'}`}
                style={{
                    height: `${height}px`,
                    fontSize: fontSize,
                }}
            >
                로딩중...
            </div> :
            <CustomSelect
                height={height}
                position={position}
                fontSize={fontSize}
                disabled={disabled}
                isFull={false}
                width={width ? width : 'w-[320px]'}
                className={className}
                option={list}
                onInputChange={(value) => {
                    setKeyword(value)
                }}
                value={value ? filterdSelect(list, String(value)) : null}
                placeholder={placeholder}
                onChange={(_, allData) => {
                    onChange?.(allData)
                }}
            />
    )
}

export default PortSelect